import { getAll, put } from "./CommonServices/httpService"
import { Permission } from "../types/Permission/Permission"

export const listPermissions = async (projectTemplate: number) => {
    const result = await getAll<Permission[]>(`/Permissions?projectTemplate=${projectTemplate}`)
    return result.data
}

export const updatePermissions = async (workerId: number, permissions: number[]) => {
    const result = await put(`/Permissions/${workerId}`, permissions)
    return result.success
}

export const getWorkerPermissions = async (workerId: number) => {
    const result = await getAll<number[]>(`/Permissions/${workerId}`)
    return result.data
}